<script lang="ts">
    import { Col, Nav, NavLink, NavItem } from "sveltestrap";
    import { ActiveandDisabledLinks, Dashboard } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import FeatherIcon from "svelte-feather-icon";
    import Dropdownactive from "./Dropdownactive.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Navs/Navs.json"
</script>
<Col md="6">
    <Card cardHeaderprops="pb-0" cardProps="height-equal" headerTitle={ActiveandDisabledLinks}>
        <div slot="contentbody">
            <Nav vertical class="icon-lists border navs-icon">
                <NavItem>
                    <NavLink active>
                        <FeatherIcon icon="home" />
                        <span> {Dashboard}</span>
                    </NavLink>
                </NavItem>
                {#each data.activedropdown as navItem}
                    <NavItem>
                        <NavLink disabled={navItem.class}> 
                            <FeatherIcon icon={navItem.icon} />
                            <span>{navItem.name}</span>
                        </NavLink>
                    </NavItem>
                {/each}
            </Nav>
            <Dropdownactive/>
        </div>
    </Card>
</Col>